module.exports = __webpack_public_path__ + "static/media/ocurrence.ad0c969d.svg";